import { CoreExecutorResult, } from "../../core/index.js";
import { DataPsmExecutorResultFactory, loadDataPsmSchema, removeValue } from "./data-psm-executor-utils.js";
export async function executeDataPsmDeleteOr(reader, createNewIdentifier, operation) {
    const schema = await loadDataPsmSchema(reader);
    if (schema === null) {
        return DataPsmExecutorResultFactory.missingSchema();
    }
    // todo check if the entity is really or and is not referenced by other entities
    schema.dataPsmParts = removeValue(operation.dataPsmOr, schema.dataPsmParts);
    return CoreExecutorResult.createSuccess([], [schema], [operation.dataPsmOr]);
}
//# sourceMappingURL=data-psm-delete-or-executor.js.map